<script>
import { ElMessage } from "element-plus";
import axios from "axios";
import { useStore } from "vuex";
import SparkMD5 from "spark-md5";
import { v4 as uuid4v } from "uuid";
import ProductMenu from "./ProductMenu.vue";

export default {
  components: {
    ProductMenu,
  },
  data() {
    return {
      brandVisible: false,
      dialogVisible: false,
      hasParent: false,
      updata: false,
      typefrom: {
        name: "",
        level: 0,
        parent: "",
        description: "",
        brand: "",
      },
      brandfrom: {
        name: "",
        file: "",
      },
      imageUrl: "",
      oldPath: "",
      levels: [
        { label: "初级", value: 0 },
        { label: "一级", value: 1 },
        { label: "二级", value: 2 },
        { label: "三级", value: 3 },
        { label: "四级", value: 4 },
        { label: "五级", value: 5 },
        { label: "六级", value: 6 },
        { label: "七级", value: 7 },
        { label: "八级", value: 8 },
        { label: "九级", value: 9 },
      ],
      parents: [],
      // 表单验证规则
      rulesall: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        brand: [{ required: true, message: "请选择品牌", trigger: "change" }],
        level: [{ required: true, message: "请选择层级", trigger: "change" }],
        parent: [{ required: true, message: "请选择父类", trigger: "change" }],
      },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        brand: [{ required: true, message: "请选择品牌", trigger: "change" }],
        level: [{ required: true, message: "请选择层级", trigger: "change" }],
      },
      inner_width: 1020,
      brand: "",
      selectedOptions: [],
      typeId: "",
      brandId: "",
      fileId: "",
      zancunFileId: "",
      fileStatus: 0,
      name: "",
      mod: "",
      attachNo: "",
      title: "新增产品类型",
      brandTitle: "新增品牌",
      brandStatus: 1,
      typeStatus: 1,
      MD5: "",
      productTotal: 0,
      pageSize: 9,
      currentPage: 1,
      fileData: {},
      options: [],
      productdatas: [],
      brands: [],
      store: useStore(),
      canChannge: false,
      canZong: false,
      menuTree: [],
      productTitle: "",
      menukey: false,
      typemap: [],
      // oneMenu: ["1388189942890364928", "1397535399538065408", "1397551512502140928"],
      oneMenu: ["1388172083095142400", "1397872264191410176","1399675336794308608"] /*服务器*/,
      brandType: 1,
      wenContent: "",
      wenTile: "",
      bannerPath: "",
      titleEnd: "",
      titleStar: "",
      brandMeunTitle:"",
    };
  },
  mounted() {
    this.inner_width = document.querySelector(".inner").offsetWidth;
    const user = this.store.state.userInfo;
    this.canChannge = user ? user.permission ? user.permission == 0 || user.permission == 1 : false: false;
    this.canZong = user ? (user.permission ? user.permission == 0 : false) : false;
    this.brandType = this.$route.query.type;
    this.bannerPath =
      this.brandType == 1
        ? require("../../assets/zdhbjt.png")
        : this.brandType == 2
        ? "https://omo-oss-image.thefastimg.com/portal-saas/new2023021809352291162/cms/image/a8e9c72f-c009-49b2-b25d-bc1dde486fe6.jpg"
        : this.brandType == 3?require("../../assets/jxsbs.png")
        : require("../../assets/yqybbj.png");
    this.wenTile = this.brandType == 1 ? "配电与自动化元件" : this.brandType == 2? "清洁系统" : this.brandType==3?"工业机器人":"仪器仪表";
    this.wenContent = this.brandType == 3 ? "开箱装箱打标封箱码垛AGV叉车" : "";
    this.titleEnd = this.brandType == 1 ? "元件" : this.brandType==4?"仪表":"设备";
    this.titleStar =this.brandType == 1? "配电和工业自动化": this.brandType == 2? "清洁" :this.brandType == 3?"工业机械":"仪器";
    this.brandMeunTitle=this.brandType==3?"产品分类":"品牌列表";
    this.queryBrands();
    this.findTypeAll();
    this.queryBrandTree();

    this.attachNo = uuid4v();
  },
  methods: {
    refreshAll() {
      this.typeId = "";
      this.refresh();
      this.typefrom.level = 0;
      this.hasParent = false;
      this.brandId = "";
      this.brandfrom.name = "";
      this.productTitle = "全部";
      this.clentPage();
      this.queryProducts();
    },
    // handleChange(value) {
    //   if (value) {
    //     this.typeId = value[value.length - 1];
    //   } else {
    // this.typeId = "";
    // this.refresh();
    // this.typefrom.level = 0;
    // this.hasParent = false;
    //   }
    //   this.clentPage();
    //   this.queryProducts();
    // },
    // brandChange(value) {
    //   if (value) {
    //     this.brandId = value;
    //   } else {
    // this.brandId = "";
    // this.brandfrom.name = "";
    //   }
    //   this.clentPage();
    //   this.queryTypes();
    //   this.queryProducts();
    // },
    // 打开弹窗
    openDialog() {
      this.dialogVisible = true;
      this.updata = this.typeId && this.typeId != "";
      if (this.updata) {
        this.getType();
        this.title = "编辑产品类型";
      } else {
        this.title = "新增产品类型";
      }
    },
    openBrandDialog() {
      this.brandVisible = true;
      this.brandUpdata = this.brandId && this.brandId != "";
      if (this.brandUpdata) {
        this.getBrand();
        this.brandTitle = "编辑品牌";
      } else {
        this.imageUrl = "";
        this.brandTitle = "新增品牌";
      }
    },
    submitForm(Ref) {
      this.$refs[Ref].validate((valid) => {
        if (valid) {
          // 提交数据到接口
          // submitToApi();
          const productTypeDto = {
            name: this.typefrom.name,
            level: this.typefrom.level,
            parentId: this.typefrom.parent,
            description: this.typefrom.description,
            id: this.typeId,
            status: this.typeStatus,
            brandId: this.typefrom.brand,
          };
          // 提交数据到接口
          axios
            .post("/productType/save", productTypeDto, {
              Headers: {
                "Content-Type": "application/json;charset=utf-8",
              },
            }) // 使用创建的api实例: api.post('/your-endpoint', payload)
            .then((response) => {
              // 处理接口返回的结果
              if (response.data.code === 200) {
                ElMessage.success("提交成功");
                this.refresh();
                this.typefrom.level = 0;
                this.dialogVisible = false;
                this.hasParent = false;
                this.findTypeAll();
                // this.queryTypes();
                this.queryBrandTree();
                this.menukey = !this.menukey;
              } else {
                ElMessage.error("提交失败：" + response.data.message);
              }
            })
            .catch((error) => {
              // 处理请求错误
              ElMessage.error("请求失败，请检查网络或接口地址");
              console.error("提交失败：", error);
            });
        } else {
          ElMessage.error("请填写所有必填项");
          return false;
        }
      });
    },
    levelChange(value) {
      if (value && value != 0) {
        // 提交数据到接口
        const productTypeDto = {
          level: this.typefrom.level - 1,
          id: this.typeId,
          brandId: this.typefrom.brand,
        };
        axios
          .post("/productType/queryParentByLevel", productTypeDto, {
            Headers: {
              "Content-Type": "application/json;charset=utf-8",
            },
          }) // 使用创建的api实例: api.post('/your-endpoint', payload)
          .then((response) => {
            // 处理接口返回的结果
            if (response.data.code === 200) {
              ElMessage.success("数据获取成功");
              this.parents = response.data.data;
              this.hasParent = true;
              if (this.updata) {
                this.typefrom.parent = "";
              } else {
                this.typefrom.name = "";
                this.typefrom.parent = "";
                this.typefrom.description = "";
              }
            } else {
              ElMessage.error("数据获取失败：" + response.data.description);
              this.typefrom.level = 0;
              this.hasParent = false;
            }
          })
          .catch((error) => {
            // 处理请求错误
            ElMessage.error("请求失败，请检查网络或接口地址");
            console.error("数据获取失败：", error);
            this.hasParent = false;
            this.typefrom.level = 0;
          });
      } else {
        this.hasParent = false;
        if (!this.updata) {
          this.refresh();
        } else {
          this.typefrom.parent = "";
        }
      }
    },
    refresh() {
      this.typefrom.name = "";
      this.typefrom.parent = "";
      this.typefrom.description = "";
      this.typefrom.brand = "";
    },
    queryTypes() {
      if (this.brandId) {
        const typeDto = {
          brandId: this.brandId,
        };
        // 提交数据到接口
        axios
          .post("/productType/query", typeDto, {
            Headers: {
              "Content-Type": "application/json;charset=utf-8",
            },
          }) // 使用创建的api实例: api.post('/your-endpoint', payload)
          .then((response) => {
            // 处理接口返回的结果
            if (response.data.code === 200) {
              this.options = response.data.data;
            } else {
              this.options = [];
              ElMessage.error("请求失败" + response.data.description);
            }
          })
          .catch((error) => {
            // 处理请求错误
            ElMessage.error("请求失败，请检查网络或接口地址");
            console.error("提交失败：", error);
          });
      } else {
        this.options = [];
      }
    },
    findTypeAll() {
      axios
        .post("/productType/findAll") // 使用创建的api实例: api.post('/your-endpoint', payload)
        .then((response) => {
          // 处理接口返回的结果
          if (response.data.code === 200) {
            this.typemap = response.data.data;
          } else {
            this.typemap = [];
            ElMessage.error("请求失败" + response.data.description);
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("提交失败：", error);
        });
    },
    queryBrands() {
      axios
        .get("/brand/query", {
          params: { type: this.brandType },
        }) // 使用创建的api实例: api.post('/your-endpoint', payload)
        .then((response) => {
          // 处理接口返回的结果
          if (response.data.code === 200) {
            this.brands = response.data.data;
          } else {
            this.brands = [];
            // ElMessage.error("请求失败" + response.data.description);
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("提交失败：", error);
        });
    },
    queryBrandTree() {
      axios
        .get("/brand/queryTree", {
          params: { type: this.brandType },
        }) // 使用创建的api实例: api.post('/your-endpoint', payload)
        .then((response) => {
          // 处理接口返回的结果
          if (response.data.code === 200) {
            if (!this.oneMenu.includes(response.data.data[0].value)) {
              this.oneMenu.push(response.data.data[0].value);
            }
            // console.log("one-----",this.oneMenu)
            this.menuTree = response.data.data;
            this.brandId = response.data.data[0].value;
            // console.log("brandId--", this.brandId);
            this.queryProducts();
          } else {
            this.menuTree = [];
            this.oneMenu = [];
            // ElMessage.error("请求失败" + response.data.description);
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("提交失败：", error);
        });
    },
    getType() {
      // 提交数据到接口
      axios
        .get("/productType/getById", {
          params: { Id: this.typeId },
        }) // 使用创建的api实例: api.post('/your-endpoint', payload)
        .then((response) => {
          // 处理接口返回的结果
          if (response.data.code === 200) {
            ElMessage.success("数据获取成功");
            this.typefrom.level = response.data.data.level;
            this.typefrom.description = response.data.data.description;
            this.typefrom.name = response.data.data.name;
            this.typefrom.brand = response.data.data.brandId;
            this.parents = [
              { id: response.data.data.parentId, name: response.data.data.parentName },
            ];
            this.typefrom.parent = response.data.data.parentId;
            this.hasParent = response.data.data.level == 0 ? false : true;
          } else {
            ElMessage.error("数据获取失败：" + response.data.description);
            this.typefrom.level = 0;
            this.hasParent = false;
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("数据获取失败：", error);
          this.hasParent = false;
          this.typefrom.level = 0;
        });
    },
    getBrand() {
      // 提交数据到接口
      axios
        .get("/brand/get", {
          params: { Id: this.brandId },
        }) // 使用创建的api实例: api.post('/your-endpoint', payload)
        .then((response) => {
          // 处理接口返回的结果
          if (response.data.code === 200) {
            ElMessage.success("数据获取成功");
            this.brandfrom.name = response.data.data.name;
            this.brandfrom.file = response.data.data.attachmentId;
            if (response.data.data.attachmentId) {
              this.getFileById(response.data.data.attachmentId);
            }
            this.fileStatus = 1;
          } else {
            ElMessage.error("数据获取失败：" + response.data.description);
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("数据获取失败：", error);
        });
    },
    getFileById(attachmentId) {
      // 提交数据到接口
      axios
        .get("/attachment/getById", {
          params: { Id: attachmentId },
        }) // 使用创建的api实例: api.post('/your-endpoint', payload)
        .then((response) => {
          // 处理接口返回的结果
          if (response.data.code === 200) {
            ElMessage.success("数据获取成功");
            this.imageUrl = response.data.data.path;
            this.oldPath = response.data.data.path;
            this.zancunBrandId = response.data.data.id;
            this.fileId = attachmentId;
          } else {
            ElMessage.error("数据获取失败：" + response.data.description);
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("数据获取失败：", error);
        });
    },
    deleteType() {
      this.$confirm(
        "此操作将永久删除该类型，及下架该类型下的相关产品, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          // 提交数据到接口
          axios
            .get("/productType/delete", {
              params: { Id: this.typeId },
            }) // 使用创建的api实例: api.post('/your-endpoint', payload)
            .then((response) => {
              // 处理接口返回的结果
              if (response.data.code === 200) {
                this.refresh();
                this.typefrom.level = 0;
                this.dialogVisible = false;
                this.hasParent = false;
                // this.queryTypes();
                this.findTypeAll();
                this.queryBrandTree();
                this.menukey = !this.menukey;
                this.queryProducts();
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              } else {
                ElMessage.error("删除失败：" + response.data.description);
              }
            })
            .catch((error) => {
              // 处理请求错误
              ElMessage.error("请求失败，请检查网络或接口地址");
              console.error("数据获取失败：", error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    deleteBrand() {
      this.$confirm(
        "此操作将永久删除该品牌，及下架该品牌下的相关产品和品类，是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          const brandDto = {
            id: this.brandId,
            status: 1,
            name: this.brandfrom.name,
            attachmentId: this.fileId,
          };
          // 提交数据到接口
          axios
            .post("/brand/delete", brandDto, {
              Headers: {
                "Content-Type": "application/json;charset=utf-8",
              },
            }) // 使用创建的api实例: api.post('/your-endpoint', payload)
            .then((response) => {
              // 处理接口返回的结果
              if (response.data.code === 200) {
                this.brandId = "";
                this.brandfrom.name = "";
                this.brandVisible = false;
                this.brand = "";
                this.queryBrands();
                this.findTypeAll();
                // this.queryTypes();
                this.queryBrandTree();
                this.menukey = !this.menukey;
                this.queryProducts();
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              } else {
                ElMessage.error("品牌删除失败" + response.data.message);
              }
            })
            .catch((error) => {
              // 处理请求错误
              ElMessage.error("请求失败，请检查网络或接口地址");
              console.error("品牌删除失败", error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    submitBrand(Ref) {
      this.$refs[Ref].validate((valid) => {
        if (valid) {
          const brandDto = {
            id: this.brandId,
            status: 1,
            name: this.brandfrom.name,
            attachmentId: this.fileId,
            type: this.brandType,
          };
          // 提交数据到接口
          axios
            .post("/brand/save", brandDto, {
              Headers: {
                "Content-Type": "application/json;charset=utf-8",
              },
            }) // 使用创建的api实例: api.post('/your-endpoint', payload)
            .then((response) => {
              // 处理接口返回的结果
              if (response.data.code === 200) {
                if (brandDto.attachmentId) {
                  this.setFileStatus();
                }
                this.brandId = response.data.data.id;
                this.brandfrom.name = "";
                this.brandVisible = false;
                this.brand = "";
                this.queryBrands();
                this.queryBrandTree();
                this.menukey = !this.menukey;
              } else {
                ElMessage.error("品牌保存失败" + response.data.message);
              }
            })
            .catch((error) => {
              // 处理请求错误
              ElMessage.error("请求失败，请检查网络或接口地址");
              console.error("品牌保存失败", error);
            });
        } else {
          ElMessage.error("请填写所有必填项");
        }
      });
    },
    setFileStatus() {
      this.oldPath = "";
      this.zancunBrandId = "";
      const parms = {
        id: this.fileId,
        status: 1,
      };
      // 提交数据到接口
      axios
        .post("/attachment/changeStatus", parms, {
          Headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
        }) // 使用创建的api实例: api.post('/your-endpoint', payload)
        .then((response) => {
          // 处理接口返回的结果
          if (response.data.code === 200) {
            ElMessage.success("保存成功");
            this.fileStatus = 1;
            this.imageUrl = "";
            this.oldPath = "";
            this.zancunBrandId = "";
            this.fileId = "";
          } else {
            ElMessage.error("附件保存失败" + response.data.message);
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("附件保存失败", error);
        });
    },
    handlePreview(file) {
      console.log("preview=", file);
    },
    async beforeUpload(file) {
      if (!file) {
        this.$message.error("文件丢失取消上传");
        return false;
      } else if (file.size / 1024 / 1024 > 50) {
        this.$message.error("文件不能大雨50M");
        return false;
      }
      try {
        var fileReader = new FileReader();
        //获取文件二进制数据
        fileReader.readAsArrayBuffer(file);
        const spark = new SparkMD5.ArrayBuffer();
        fileReader.onload = async (e) => {
          spark.append(e.target.result);
          this.MD5 = spark.end();
          this.localUpload(file, this.MD5);
        };
      } catch (error) {
        console.error("计算MD5值有误：", error);
        return false;
      }
      return false;
    },
    //上传文件到本地服务器
    localUpload(file, MD5) {
       const fileType=file.name.split('.')[1];
      const formData = new FormData();
      formData.append("file", file);
      formData.append("md5", MD5);
      formData.append("category", "brand");
      formData.append("size", file.size);
      formData.append("originalName", file.name);
      formData.append("type", fileType);
      formData.append("method", 0);
      formData.append("attachNo", this.attachNo);
      formData.append("oldId", this.zancunBrandId);
      formData.append("oldPath", this.oldPath);
      formData.append("status", this.fileStatus);
      formData.append("id", this.fileId);
      // 提交数据到接口
      axios
        .post("/attachment/localUpload", formData, {
          Headers: {
            "Content-Type": "multipart/form-data",
          },
        }) // 使用创建的api实例: api.post('/your-endpoint', payload)
        .then((response) => {
          // 处理接口返回的结果
          if (response.data.code === 200) {
            ElMessage.success("提交成功");
            this.imageUrl = response.data.data.path;
            this.oldPath = response.data.data.path;
            this.zancunBrandId = response.data.data.id;
            this.fileId = response.data.data.id;
            this.fileStatus = 2;
          } else {
            ElMessage.error("提交失败：" + response.data.message);
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("提交失败：", error);
        });
    },
    openDetailPage(id) {
      if (id) {
        this.$router.push("/ProductDetailPage?id=" + id + "&type=" + this.brandType);
      } else {
        this.$router.push("/ProductDetailPage?type=" + this.brandType);
      }
    },
    queryProducts() {
      if (!this.brandId) {
        return;
      }
      const productDto = {
        name: this.name,
        model: this.mod,
        typeId: this.typeId,
        brandId: this.brandId,
        page: this.currentPage,
        size: this.pageSize,
      };
      // 提交数据到接口
      axios
        .post("/product/queryList", productDto, {
          Headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
        }) // 使用创建的api实例: api.post('/your-endpoint', payload)
        .then((response) => {
          // 处理接口返回的结果
          if (response.data.code === 200) {
            this.productTotal = response.data.data.totalElements;
            this.productdatas = response.data.data.content;
          } else {
            this.productdatas = [];
            this.productTotal = 0;
            ElMessage.error("获取产品失败" + response.data.message);
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("获取产品失败", error);
        });
    },
    clentPage() {
      this.pageSize = 9;
      this.currentPage = 1;
    },
    handleSizeChange(val) {
      if (this.pageSize != val) {
        this.pageSize = val;
        this.queryProducts();
      }
    },
    handleCurrentChange(val) {
      if (this.currentPage != val) {
        this.currentPage = val;
        this.queryProducts();
      }
    },
    inputChange() {
      this.clentPage();
      this.queryProducts();
    },
    handleOpen(key, keyPath) {
      if (keyPath.length == 1) {
        this.brandId = key;
        this.typeId = "";
        this.clentPage();
        this.queryProducts();
        this.productTitle = this.brands.filter((item) => item.id == this.brandId)[0].name;
      }
    },
    handleSelect(key, keyPath) {
      if (keyPath.length > 1) {
        this.brandId = keyPath[0];
        this.typeId = keyPath[keyPath.length - 1];
        this.clentPage();
        this.queryProducts();
        this.productTitle =
          this.brands.filter((item) => item.id == this.brandId)[0].name +
          "-" +
          this.typemap.filter((item) => item.id == this.typeId)[0].name;
      } else {
        this.brandId = key;
        this.typeId = "";
        this.clentPage();
        this.queryProducts();
        this.productTitle = this.brands.filter((item) => item.id == this.brandId)[0].name;
      }
    },
    // handleRemove(file) {
    //   console.log("remove=", file);
    // },
    // handleSuccess(file) {
    //   console.log("success=", file);
    // },
  },
};
</script>
<template>
  <div class="Product_banner">
    <div>
      <!-- <img v-if="this.brandType == 1" src="../../assets/about.jpg" /> -->
      <img :src="this.bannerPath" />
      <div class="product_wen">
        <div class="product_wen_title">{{ this.wenTile }}</div>
        <div class="product_wen_content">{{ this.wenContent }}</div>
      </div>
    </div>
  </div>
  <div class="contaier product">
    <div class="inner">
      <div class="content_title">
        <div class="flex title1">
          <div class="flex-item left">
            <span class="line_"></span>
          </div>
          <div v-if="this.brandType&&(this.brandType==2||this.brandType==4)" class="text">
            <span>{{ this.titleStar }}</span>
            <span class="red">{{ this.titleEnd }}</span>
          </div>
          <div v-if="this.brandType&&this.brandType==3" class="text" style="width: 200px;">
            <span>{{ this.titleStar }}</span>
            <span class="red">{{ this.titleEnd }}</span>
          </div>
          <div v-if="this.brandType&&this.brandType==1" class="text" style="width: 300px;">
            <span>{{ this.titleStar }}</span>
            <span class="red">{{ this.titleEnd }}</span>
          </div>
          <div class="flex-item right">
            <span class="line_"></span>
          </div>
        </div>
        <div class="title2">PRODUCT</div>
      </div>
      <div class="desc">
        <ul class="query">
          <el-dialog v-model="brandVisible" :title="this.brandTitle" width="400px">
            <el-form :model="brandfrom" :rules="rulesall" ref="brandfrom">
              <el-form-item label="名称" prop="name" label-width="120px">
                <el-input v-model="brandfrom.name" placeholder="请输入名称" />
              </el-form-item>
              <el-form-item prop="file">
                <el-upload
                  v-model="brandfrom.file"
                  :limit="1"
                  :on-preview="handlePreview"
                  :before-upload="beforeUpload"
                  :data="this.fileData"
                  action="kekon/brand"
                  class="avatar-uploader"
                  accept=".png,.jpg,.jpeg,.gif"
                >
                  <img v-if="this.imageUrl" :src="this.imageUrl" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
            </el-form>
            <template #footer>
              <span class="dialog-footer">
                <el-button v-if="this.brandUpdata" class="delete" @click="deleteBrand"
                  >删除</el-button
                >
                <el-button @click="brandVisible = false">取消</el-button>
                <el-button type="primary" @click="submitBrand('brandfrom')"
                  >确认提交</el-button
                >
              </span>
            </template>
          </el-dialog>
          <el-dialog v-model="dialogVisible" :title="this.title" width="500px">
            <el-form
              v-if="this.hasParent"
              :model="typefrom"
              :rules="rulesall"
              ref="typefrom"
            >
              <el-form-item label="名称" prop="name" label-width="120px">
                <el-input v-model="typefrom.name" placeholder="请输入名称" />
              </el-form-item>
              <el-form-item label="品牌" prop="brand" label-width="120">
                <el-select v-model="typefrom.brand" clearable placeholder="请选择品牌">
                  <el-option
                    v-for="item in brands"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="层级" prop="level" label-width="120px">
                <el-select
                  :disabled="this.typefrom.brand ? false : true"
                  v-model="typefrom.level"
                  placeholder="请选择层级"
                  @change="levelChange"
                  clearable
                >
                  <el-option
                    v-for="level in levels"
                    :key="level.value"
                    :label="level.label"
                    :value="level.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="父类" prop="parent" label-width="120px">
                <el-select v-model="typefrom.parent" placeholder="请选择父类" clearable>
                  <el-option
                    v-for="parent in parents"
                    :key="parent.id"
                    :label="parent.name"
                    :value="parent.id"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="简介" prop="description" label-width="120px">
                <el-input
                  v-model="typefrom.description"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入简介"
                />
              </el-form-item>
            </el-form>
            <el-form
              v-if="!this.hasParent"
              :model="typefrom"
              :rules="rules"
              ref="typefrom"
            >
              <el-form-item label="名称" prop="name" label-width="120px">
                <el-input v-model="typefrom.name" placeholder="请输入名称" />
              </el-form-item>
              <el-form-item label="品牌" prop="brand" label-width="120">
                <el-select v-model="typefrom.brand" clearable placeholder="请选择品牌">
                  <el-option
                    v-for="item in brands"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="层级" prop="level" label-width="120px">
                <el-select
                  :disabled="this.typefrom.brand ? false : true"
                  v-model="typefrom.level"
                  placeholder="请选择层级"
                  @change="levelChange"
                  clearable
                >
                  <el-option
                    v-for="level in levels"
                    :key="level.value"
                    :label="level.label"
                    :value="level.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="简介" prop="description" label-width="120px">
                <el-input
                  v-model="typefrom.description"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入简介"
                />
              </el-form-item>
            </el-form>
            <template #footer>
              <span class="dialog-footer">
                <el-button v-if="this.updata" class="delete" @click="deleteType"
                  >删除</el-button
                >
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitForm('typefrom')"
                  >确认提交</el-button
                >
              </span>
            </template>
          </el-dialog>
          <!-- <li class="query_item"> -->
          <!-- <span class="demonstration">品牌：</span> -->
          <!-- <el-button
                  v-if="this.canZong"
                  class="btn"
                  @click="openBrandDialog"
                  circle
                ></el-button> -->

          <!-- <el-select
                  class="inp"
                  v-model="brand"
                  @change="brandChange"
                  clearable
                  placeholder="请选择品牌"
                >
                  <el-option
                    v-for="item in brands"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                    <el-popover
                      placement="right"
                      :title="item.name"
                      width="225"
                      trigger="hover"
                    >
                      <img v-if="item.path" :src="item.path" width="200" height="100" />
                      <img v-else src="../../assets/wutup.jpg" width="200" height="100" />
                      <template #reference>
                        <div style="width: 100%">
                          {{ item.name }}
                        </div>
                      </template>
                    </el-popover>
                  </el-option>
                </el-select> -->
          <!-- </li> -->

          <!-- <li class="query_item">
                <div class="block"> -->
          <!-- <span class="demonstration">类型：</span>
                  <el-button
                    v-if="this.canZong"
                    class="btn"
                    @click="openDialog"
                    circle
                  ></el-button> -->

          <!-- <el-cascader
                    v-model="selectedOptions"
                    :options="options"
                    @change="handleChange"
                    clearable
                    placeholder="请选择类型"
                  >
                    <template #default="{ node }">
                      <div style="width: 100%">
                        {{ node.label }}
                      </div>
                    </template> -->
          <!-- <template #default="{ node, data }"> 放置弹出提示
                    <div>
                      <el-popover
                        placement="top-start"
                        title="简介"
                        width="225"
                        trigger="hover"
                        :content="data.description"
                      >
                        <template #reference>
                          <div style="width: 100%">
                            {{ node.label }}
                          </div>
                        </template>
                      </el-popover>
                    </div>
                  </template> -->
          <!-- </el-cascader> -->
          <!-- </div>
              </li> -->
          <li class="query_item">
            <span class="demonstration">名称：</span>
            <el-input
              class="inp"
              v-model="name"
              placeholder="请输入内容"
              clearable
              @change="inputChange"
            ></el-input>
          </li>
          <li class="query_item">
            <span class="demonstration">型号：</span>
            <el-input
              class="inp"
              v-model="mod"
              placeholder="请输入内容"
              clearable
              @change="inputChange"
            ></el-input>
            <el-button @click="refreshAll" class="btn" circle>重置</el-button>
          </li>
        </ul>
      </div>
      <div class="pannel flex">
        <div class="brand-menu">
          <el-row class="tac">
            <el-col :span="24">
              <h2 class="mb-2 menu-title">{{ this.brandMeunTitle }}</h2>
              <el-menu
                :key="menukey"
                default-active="2"
                :default-openeds="this.oneMenu"
                class="el-menu-vertical-demo"
                @select="handleSelect"
                @open="handleOpen"
              >
                <ProductMenu :tree-data="this.menuTree" :max-depth="5"></ProductMenu>
              </el-menu>
            </el-col>
          </el-row>
          <div class="menu-btn">
            <el-button v-if="this.canZong" @click="openBrandDialog" style="width: 45%"
              >品牌：新增/修改</el-button
            >
            <el-button v-if="this.canZong" @click="openDialog" style="width: 45%"
              >类型：新增/修改</el-button
            >
          </div>
        </div>
        <div class="jiange"></div>
        <div class="product-con">
          <div v-if="this.productTitle" class="product-title">
            {{ this.productTitle }}
          </div>
          <div class="flex line">
            <div
              v-for="(item, index) in productdatas"
              :key="item.id"
              :style="{ width: (inner_width - 10) / 4 + 'px' }"
              class="product_box"
            >
              <div class="product_item_split"></div>
              <div
                class="product_item"
                @click="openDetailPage(item.id)"
                :style="{
                  width:
                    inner_width / 4 -
                    (index == 0 || index == productdatas.length - 1 ? 15 : 30) +
                    'px',
                }"
              >
                <div class="header">
                  <img v-if="item.path" :src="item.path" />
                  <img v-else src="../../assets/wutup.jpg" />
                </div>
                <div class="product_item_title">
                  {{ item.name }}
                </div>
              </div>
              <div class="product_item_split"></div>
            </div>
            <div
              v-if="this.canChannge"
              :style="{ width: (inner_width - 10) / 4 + 'px' }"
              class="product_box"
            >
              <div class="product_item_split"></div>
              <div class="product_item" @click="openDetailPage()">
                <img class="addBtn" src="../../assets/addbig.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="block" v-if="this.productTotal != 0">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="this.currentPage"
          :page-sizes="[9, 30, 60, 90]"
          :page-size="this.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="this.productTotal"
          class="full-width"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<style>
.Product_banner {
  height: 470px;
  position: relative;
}
.Product_banner img {
  width: 100%;
  height: 460px;
  position: absolute;
}
.product_wen {
  position: absolute;
  width: 100%;
  background: rgba(134, 134, 134, 0.2);
  height: 98%;
  color: #ffffff;
  text-align: center;
}
.product_wen_title {
  font-size: 50px;
  font-weight: 900;
  letter-spacing: 10px;
  /* font-style: oblique; */
  margin-top: 140px;
}
.product_wen_content {
  font-size: 16px;
  margin-top: 5px;
  letter-spacing: 1px;
}
.product .line {
  flex-wrap: wrap;
  padding-top: 10px;
}
.product .product_box {
  margin-bottom: 40px;
  display: flex;
}
.product .content_title {
  margin-bottom: 20px;
}
.product .product_item_split {
  width: 20px;
  height: 100px;
}
.product {
  padding-top: 25px;
}
.product .pannel {
  /* padding-bottom: 30px; */
  border-radius: 3px;
  /* box-shadow: 0 0 1px 3px rgba(0, 0, 0, 0.1); */
  background: #ffffff;
  margin-bottom: 20px;
}
.product .pannel .brand-menu {
  box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.1);
  width: 23%;
}
.product .pannel .brand-menu .menu-title {
  text-align: center;
  color: #3b3b3bd5;
}
.product .pannel .brand-menu .menu-btn {
  margin-top: 20px;
  text-align: center;
  width: 100%;
}
.brand-menu .menu_box {
  width: 100%;
  height: 45px;
  line-height: 40px;
}
.brand-menu .menu_box:hover {
  background: #1b77f0c2;
}
.product .pannel .jiange {
  width: 1px;
  padding: 10px;
}
.product-title {
  width: 100%;
  /* background: #f8f8f8; */
  /* background: rgba(0, 98, 255, 0.3); */
  height: 50px;
  line-height: 50px;
  font-size: 22px;
  color: #3b3b3bd5;
  text-align: center;
}
.product .pannel .product-con {
  background: rgba(226, 226, 226, 0.08);
  width: 75%;
}
.product .desc {
  line-height: 35px;
  font-size: 16px;
  text-indent: 2em;
  padding-bottom: 20px;
}

.product .pannel .line .product_item {
  background: #f8f8f8;
  border-radius: 3px;
  border: 2px solid #efefef;
  cursor: pointer;
  box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.1);
}
.product .pannel .line .product_item:hover {
  box-shadow: 0 0 10px 5px rgba(41, 148, 248, 0.3);
}
.product .pannel .line .product_item:hover .header img {
  max-width: 100%;
  width: 330px;
  /* height: 290px; */
  justify-content: center;
  padding-top: 5px;
}
.product .product_item_split {
  width: 20px;
  height: 100px;
}
.product .pannel .line .product_item .header {
  text-align: center;
  vertical-align: middle;
  align-items: center;
  justify-content: center;
  display: flex;
  height: 300px;
}
.product .pannel .line .product_item .header img {
  max-height: 100%;
  width: 300px;
  /* height: 260px; */
  padding-top: 20px;
  padding-bottom: 5px;
}
.product .pannel .line .product_item .product_item_title {
  background: rgba(38, 121, 255, 0.4);
  text-align: center;
  height: 54px;
  line-height: 54px;
  font-size: 16px;
  width: 100%;
  color: #ffffff;
}
.product .pannel .line .product_item:hover .product_item_title {
  background: #1b77f0c2;
  font-size: 17px;
  color: #ffffff;
}

/* .product .pannel .line .product_item .product_item_desc {
  text-align: center;
  height: 35px;
  line-height: 35px;
  font-size: 14px;
  color: #816b53;
  width: 300px;
  overflow: hidden; 隐藏溢出的文本
  text-overflow: ellipsis; 显示省略号
  white-space: nowrap; 防止文本换行
} */
.query {
  list-style: none;
}
.query .query_item {
  display: inline-block;
  width: 45%;
  font-size: 18px;
  text-align: center;
  color: #999898;
  cursor: pointer;
  text-decoration: none;
  position: relative;
}
.query .inp {
  width: 240px;
}
.query .query_item .btn {
  width: 40px;
  height: 40px;
  font-size: 12px;
  margin-left: 120px;
}
.dialog-footer .delete:hover {
  background: rgba(255, 89, 89, 0.726);
  color: #fa3d3d;
}

.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background: #eeeeee;
  margin-left: 32px;
}
.avatar-uploader:hover {
  /* border-color: #409eff; */
  box-shadow: 0 0 10px 5px rgba(248, 92, 41, 0.3);
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 300px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.avatar {
  width: 270px;
  height: 100px;
  display: block;
  padding-right: 30px;
  padding-top: 20px;
}
.addBtn {
  width: 280px;
  height: 320px;
  padding-left: 10px;
  padding-top: 20px;
}
.product .pannel .line .product_item:hover .addBtn {
  width: 300px;
  height: 360px;
  padding-left: 0px;
  padding-top: 0px;
}
.full-width {
  cursor: pointer;
  margin-right: 1%;
  margin-left: 1%;
  justify-content: center;
  margin-bottom: 20px;
}
</style>
